import React from 'react';
import { DocumentEditor } from '@onlyoffice/document-editor-react';
import { ONLYOFFICE_SERVER_URL, API_BASE_URL } from '../../services/api';

const OnlyOfficeEditor = ({ doc, user, documentType, customCallbackUrl }) => {
  if (!doc) return null;

  const token = localStorage.getItem('company_token');

  let fileUrl = (doc.fileUrl.startsWith('http') 
    ? doc.fileUrl 
    : `${API_BASE_URL}${doc.fileUrl}`) + `?t=${new Date(doc.updatedAt).getTime()}`;

  if (token) {
    fileUrl += `&token=${token}`;
  }

  // Force IP for callback so ONLYOFFICE container can reach backend
  const callbackUrl = customCallbackUrl || `${API_BASE_URL}/api/documents/callback/${doc._id}`;

  const onDocumentReady = (event) => {
    console.log('Document is ready');
  };

  const onLoadComponentError = (errorCode, errorDescription) => {
    console.error('Error loading ONLYOFFICE:', errorCode, errorDescription);
  };

  // Determine file type for ONLYOFFICE
  const getFileType = (fileName) => {
    const ext = fileName.split('.').pop().toLowerCase();
    return ext;
  };

  const config = {
    document: {
      fileType: getFileType(doc.fileName),
      key: doc._id + "_" + new Date(doc.updatedAt).getTime(), // Ensure unique key for each version
      title: doc.title || doc.fileName,
      url: fileUrl,
      permissions: {
        edit: true,
        download: true,
        print: true,
        fillForms: true,
      },
    },
    documentType: documentType, // 'word', 'cell', or 'slide'
    editorConfig: {
      callbackUrl: callbackUrl,
      user: {
        id: user._id,
        name: user.name || 'User',
      },
      lang: 'en',
      mode: 'edit',
      customization: {
        forcesave: true,
        chat: false,
        comments: false,
        compactHeader: true, // Makes the header much smaller
        compactToolbar: true, // Makes the toolbar more compact
        help: false,
        hideRightMenu: false,
        showReviewChanges: false,
        toolbarNoTabs: false,
        unit: 'cm',
        zoom: 100,
        hideTabs: false, // Ensure tabs are NOT hidden
        hideNotes: false,
        showReviewChanges: false,
        spellcheck: true,
        compatibleFeatures: true,        logo: {
          image: "", // Remove ONLYOFFICE logo to save space
          imageEmbedded: "",
          url: ""
        }
      },
    },
    height: '100%',
    width: '100%',
  };

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <DocumentEditor
        id={`${doc._id}_editor`}
        documentServerUrl={ONLYOFFICE_SERVER_URL}
        config={config}
        events_onDocumentReady={onDocumentReady}
        onLoadComponentError={onLoadComponentError}
      />
    </div>
  );
};

export default OnlyOfficeEditor;




